import { render, staticRenderFns } from "./receiveDetail.vue?vue&type=template&id=49762eb3&scoped=true"
import script from "./receiveDetail.vue?vue&type=script&lang=js"
export * from "./receiveDetail.vue?vue&type=script&lang=js"
import style0 from "./receiveDetail.vue?vue&type=style&index=0&id=49762eb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49762eb3",
  null
  
)

export default component.exports